var _path, _path2, _path3, _ellipse, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenBox = function SvgGreenBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 69,
    viewBox: "0 0 80 69",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9115 18.0276L41.8153 6.54378C43.6502 5.48541 45.905 5.48541 47.7398 6.54378L67.6437 18.0276C67.9811 18.2212 67.9321 18.6966 67.5812 18.8644L45.4247 29.4597C45.0155 29.6554 44.5397 29.6554 44.1305 29.4597L21.974 18.8644C21.6231 18.6966 21.5741 18.2212 21.9115 18.0276Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.768 34.2102C46.768 33.6325 47.0997 33.1062 47.6208 32.857L70.0319 22.1394C70.2725 22.0243 70.5579 22.1632 70.5956 22.4273C70.6332 22.702 70.6526 22.9807 70.6526 23.2619V46.0831C70.6526 48.247 69.5045 50.2447 67.6437 51.3174L47.7398 62.8013C47.2872 63.0619 46.768 62.7004 46.768 62.1781V34.2102Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9344 32.857C42.4555 33.1062 42.7872 33.6325 42.7872 34.2102V62.1781C42.7872 62.7004 42.268 63.0619 41.8153 62.8013L21.9115 51.3174C20.0507 50.2447 18.9026 48.247 18.9026 46.0831V23.2619C18.9026 23.227 18.9029 23.1921 18.9035 23.1573C18.9145 22.5153 19.6049 22.1784 20.1842 22.4554L41.9344 32.857Z",
    fill: "#27AE60"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.9461,
    cy: 21.2146,
    rx: 18.3264,
    ry: 18.3659,
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.889 21.2142C41.889 32.8065 32.5118 42.2039 20.9445 42.2039C9.37717 42.2039 0 32.8065 0 21.2142C0 9.62199 9.37717 0.224609 20.9445 0.224609C32.5118 0.224609 41.889 9.62199 41.889 21.2142ZM20.9445 39.5802C31.0659 39.5802 39.2709 31.3575 39.2709 21.2142C39.2709 11.071 31.0659 2.84831 20.9445 2.84831C10.8231 2.84831 2.61806 11.071 2.61806 21.2142C2.61806 31.3575 10.8231 39.5802 20.9445 39.5802Z",
    fill: "#6FCF97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7976 15.9668L18.3253 26.4616L13.0892 21.2142",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GreenBox.d663eb1e.svg";
export { ForwardRef as ReactComponent };